import {is_string, log} from "../support/util.js";
import {is_html_button, parent_by_tag_name} from "./element.js";

const Input_type =
{
	BUTTON: 'button',
	CHECKBOX: 'checkbox',
	COLOR: 'color',
	DATE: 'date',
	DATETIME: 'datetime',
	DATETIME_LOCAL: 'datetime-local',
	EMAIL: 'email',
	FILE: 'file',
	HIDDEN: 'hidden',
	IMAGE: 'image',
	MENU: 'menu',
	MONTH: 'month',
	NUMBER: 'number',
	PASSWORD: 'password',
	RADIO: 'radio',
	RANGE: 'range',
	RESET: 'reset',
	SEARCH: 'search',
	SELECT_MULTIPLE: 'select-multiple',
	SELECT_ONE: 'select-one',
	SUBMIT: 'submit',
	TEL: 'tel',
	TEXT: 'text',
	TEXTAREA: 'textarea',
	TIME: 'time',
	URL: 'url',
	WEEK: 'week'
};

function form_data (form)
{
	return form_data_append(form, new FormData(), (data, name, val) => data.append(name, val));
}


const requests = [];

let counter = 0;

let running = false;
export function request_queue ()
{

	return {
		add: function (request_fn) {
			counter++;
			request_fn['id'] = counter;
			if (requests.length === 2)
			{
				console.log("replace last");
				requests[1] = request_fn;
			}
			else {
				console.log("push");
				requests.push(request_fn);
			}

			this.run();
		},

		run: function ()
		{
			if (requests.length > 0 && !running)
			{
				running = true

				const id = requests[0]['id']
				console.log("run " + id)

				requests[0](id)
			}
		},

		on_complete: function (request, callback) {
			if (request['id'] === counter) {
				console.log("callback for " + counter);
				callback();
			}

			requests.shift();
			running = false;

			this.run();
		}
	};
}

function xhr_success (xhr)
{
	return xhr.status >= 200 && xhr.status < 400;
}

export function xhr_response_text (xhr)
{
	try {
		return xhr ? xhr.responseText : '';
	} catch (e)
	{
		console.log(e);
		return '';
	}
}

export function emplace_request_submit_polyfill ()
{
	(function (prototype) {
		if (typeof prototype.requestSubmit == "function") return

		prototype.requestSubmit = function (submitter) {
			if (submitter && validate_submitter(submitter, this))
			{
				submitter.click()
			}
			else {
				const temp_submitter = document.createElement("input")
				temp_submitter.type = "submit"
				temp_submitter.hidden = true

				if (submitter instanceof HTMLButtonElement) {
					if (submitter.name) {
						temp_submitter.name = submitter.name
					}

					if (submitter.value) {
						temp_submitter.value = submitter.value
					}
				}

				this.appendChild(temp_submitter)
				temp_submitter.click()
				this.removeChild(temp_submitter)
			}
		}

		function validate_submitter (submitter, form)
		{
			let r = submitter instanceof HTMLElement || false
			r = r && submitter.type === "submit" || false
			return r && submitter.form === form || false
		}
	})(HTMLFormElement.prototype);
}

export function submit_form (form, http_headers, success_callback)
{
	const data = form_data(form);
	const url = form.getAttribute('action') || window.location.href;

	submit_form_data(data, url, http_headers, success_callback);
}

export function submit_form_data (data, url, http_headers, success_callback)
{
	const on_load_callback = (xhr) => {
		const redirect_to = xhr.getResponseHeader('X-Redirect-To')
		if (!redirect_to && xhr_success(xhr) && success_callback)
		{
			success_callback(xhr);
		}
	}

	const queue = request_queue();

	queue.add((request_id) => {
		const xhr = new XMLHttpRequest;
		xhr['id'] = request_id;

		xhr.open('POST', url || window.location.href);
		for (const name in http_headers)
		{
			xhr.setRequestHeader(name, http_headers[name])
		}

		/*if (data instanceof FormData)
		 {
		 for (const pair of data.entries())
		 {
		 console.log(pair[0] + ', ' + pair[1]);
		 }
		 }*/

		xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

		xhr.onreadystatechange = () => {
			if (xhr.readyState === xhr.HEADERS_RECEIVED) {
				const redirect_to = xhr.getResponseHeader('X-Redirect-To')
				const nonce = xhr.getResponseHeader('X-Nonce')
				if (redirect_to) {
					queue.add((request_id) => {
						const xhr_redirect = new XMLHttpRequest
						xhr_redirect['id'] = request_id
						const url = new URL(redirect_to);
						const params = url.searchParams
						params.append('nonce', nonce)

						xhr_redirect.open('GET', url.toString())
						for (const name in http_headers)
						{
							xhr_redirect.setRequestHeader(name, http_headers[name])
						}

						xhr_redirect.setRequestHeader("X-Requested-With", "XMLHttpRequest")

						xhr_redirect.onload = () => queue.on_complete(xhr_redirect, () => on_load_callback(xhr_redirect))

						xhr_redirect.send();
					})

				}
			}
		}

		xhr.onload = () => queue.on_complete(xhr, () => on_load_callback(xhr))

		xhr.send(data);
	})


}

export function is_text_input (el)
{
	if(el.type) {
		switch (el.type.toLowerCase())
		{
		case Input_type.FILE:
		case Input_type.BUTTON:
		case Input_type.RESET:
		case Input_type.SUBMIT:
		case Input_type.CHECKBOX:
		case Input_type.RADIO:
			return false;
		}
	}

	return true;
}

function form_data_append (form, result, append_callback)
{
	const els = form.elements;
	if (els)
	{
		for (let el, i = 0; (el = els[i]); ++i)
		{
			if (el.form !== form || el.disabled || el.tagName === 'FIELDSET')
			{
				continue;
			}

			const name = el.name;
			switch (el.type.toLowerCase())
			{
			case Input_type.FILE:
			case Input_type.BUTTON:
			case Input_type.RESET:
			case Input_type.SUBMIT:
				break;
			default:
				const val = form_value(el);
				if (val != null)
				{
					append_callback(result, name, val);
				}
			}
		}
		// TODO: input[type=image] is not included in the form.elements collection
		return result;
	}

	return null;
}

function form_value_input_checked (el)
{
	return el.checked ? (el).value : null;
}

function form_value (el)
{
	const type = (el).type;
	switch (is_string(type) && type.toLowerCase())
	{
	case Input_type.CHECKBOX:
	case Input_type.RADIO:
		return form_value_input_checked(el);
	case Input_type.SELECT_ONE:
		return form_value_select_one(el);
	case Input_type.SELECT_MULTIPLE:
		return form_value_select_multiple(el);
	default:
		return el.value != null ? el.value : null;
	}
}

function form_value_select_one (el)
{
	var idx = (el).selectedIndex;
	return idx >= 0 ? (el).options[idx].value : null;
}

function form_value_select_multiple (el)
{
	const values = [];
	for (let option, i = 0; (option = (el).options[i]); ++i)
	{
		if (option.selected)
		{
			values.push(option.value);
		}
	}

	return values.length ? values : null;
}

export function intercept_forms (callback)
{
	let last_clicked_button;

	function on_input (e)
	{
		last_clicked_button = null;
	}

	function on_click (e)
	{
		if (is_html_button(e.target))
		{
			last_clicked_button = e.target
		}
		else {
			const button = parent_by_tag_name(e.target, 'button');
			if (button)
			{
				last_clicked_button = button;
			}
		}
	}

	function interceptor (e)
	{
		let form = this;
		if (!(form instanceof HTMLFormElement) && e && e.target)
		{
			form = e.target;
		}

		let nojs = form.classList.contains('nojs') ||
		(last_clicked_button != null && last_clicked_button.classList.contains('nojs'));
		if (!nojs)
		{
			if (e)
			{
				e.preventDefault();
			}

			callback(e, form);
		}
	}

	function submit ()
	{
		if (!this.classList.contains('nojs'))
		{
			interceptor.bind(this).call();
		}
		else {
			this._submit();
		}
	}

	HTMLFormElement.prototype._submit = HTMLFormElement.prototype.submit;
	HTMLFormElement.prototype.submit = submit
	window.addEventListener('submit', interceptor);
	window.addEventListener('click', on_click, {passive: true, capture: true});
	window.addEventListener('input', on_input, {passive: true, capture: true});
}